export enum EConnectDatabaseElementId {
  NAV_ACCOUNT_MENU_CTA = 5,
  COMMUNITY_DATA_SOURCE_BANNER_CTA = 6,
  ORG_DATA_SOURCE_BANNER_CTA = 7,
}
